<ui-subheader [subheader]="'Search Employee'">

</ui-subheader>
<div class="search-user content grid-container">
  <div class="button-container">
    <div *ngIf="isImageUploaded" class="image-container">
      <img id="uploadedImage" src="#" alt="Uploaded" style="display: none;">
      <a href="#" *ngIf="imageUrl" (click)="removeImage(); $event.preventDefault()" class="primary">Clear</a>
    </div>
        <!-- Upload Button -->
        <button type="button" class="button primary" (click)="uploadImage()">Upload</button>
        <!-- Search Button -->
        <button type="button" class="button primary" (click)="searchImage()" [disabled]="!imageUrl">Search</button>

        <button type="button" class="button primary" (click)="refreshGrid()">Load My Requests</button>
        <div class="spacer"></div>
      </div>
</div>
<div class="content grid-container">
      <div *ngIf="items.length==0" class="text-container" style="margin-top: 20px;">
        No Data!
      </div>
      <div *ngIf="items.length>0" class="table-container">
        <table>
          <thead>
            <tr>
              <th>Request Id</th>
              <th>FileName</th>
              <th>Status</th>
              <th>MatchedUsers</th>
              <th>RequestedOn</th>
              <th>CompletedOn</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of items">
              <td>{{ item.requestId }}</td>
              <td>{{ item.fileName }}</td>
              <td>{{item.status}}</td>
              <td (click)="openModal(item)"
              [ngClass]="(item.matchedImageCount == 0)?'addDisabled':'addEnabled'"
              >{{ item.matchedImageCount }}</td>
              <td>{{item.requestDate}}</td>
              <td>{{item.completedDate}}</td>
            </tr>
          </tbody>
        </table>
      </div>

</div>
